module.exports = __webpack_public_path__ + "img/16_93.b696a4f7.png";